@if (loading()) {
  <div
    class="nav-progress-bar"
    [class.nav-progress-bar--done]="navDone()"></div>
}
<router-outlet></router-outlet>
